import { useSelector, useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';

import {
    authentication,
} from '../redux/Selectors.js';

import {
    fetchBusinessPartner,
    getAuthentication
} from '../redux/Actions.js';

export const AuthenticationService = () => {
    const dispatch = useDispatch();

    const _authentication = useSelector((state) => authentication(state));

    useEffect(() => {
        if (_authentication) {
            if (_authentication.loggedOut) {
                document.getElementById('sso-status').src = '';
                dispatch(getAuthentication());
            }
            else if (_authentication.businessPartnerNumber) {
                dispatch(fetchBusinessPartner(_authentication.businessPartnerNumber));
            }
            // else if (_isSsoAuthentication) {
            //     dispatch(fetchUserProfile());
            // }
            // else if ('GUEST' === _authentication.userName) {
            //     navigate(getPage('register', _device));
            // }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_authentication]);

    return null;

}
